import { Box, Button, Typography } from '@mui/material'
import WarningIcon from 'assets/icons-color/modal-warning.png'
import { GitBook } from 'constants/externalLink'
import CoreModal from 'core/CoreModal'

interface Props {
  onClose: () => void
  onProcess: () => void
}

const BorrowWithHeighRiskModal = ({ onClose, onProcess }: Props) => {
  const Content = (
    <Box sx={{ textAlign: 'center' }}>
      <img src={WarningIcon} alt="WarningIcon" width={250} height={250} />
      <Typography variant="h5">You are at risk of</Typography>
      <Typography variant="h5" mb="16px">
        being liquidated
      </Typography>
      <Typography variant="body1" align="center">
        Your Risk ratio is exceeding the suggested safety limit. A slight fall
        in collateral value might cause your position to be liquidated.
        <br />
        Are you sure you want to proceed?
      </Typography>
      <Box
        sx={{ display: 'flex', width: '100%', gap: '16px', marginTop: '40px' }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            window.open(GitBook.genesisPool, '_blank')
          }}
          fullWidth
        >
          Learn more
        </Button>
        <Button variant="contained" onClick={onProcess} fullWidth>
          Proceed
        </Button>
      </Box>
    </Box>
  )

  return <CoreModal open content={Content} onClose={onClose} />
}

export default BorrowWithHeighRiskModal
